import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axiosClient, { getData, postData, getBaseUrl } from "../global/Globalapi";
import { CiHeart } from "react-icons/ci";
import { FaHeart } from "react-icons/fa";
import EnhancedSearchBar from './DynamicComp/EnhancedSearchBar ';
import { FiFilter } from "react-icons/fi";
import { useRef } from "react";
import swal from "sweetalert";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const Demo_4 = () => {
  const [products, setProducts] = useState([]);
  const navigate = useNavigate();
  const baseURL = axiosClient.defaults.baseURL;
const [likedProducts, setLikedProducts] = useState({});
const BASE_URL = getBaseUrl();
const noProducts = products.length === 0;
const [offAll, setOffAll] = useState(0);
useEffect(() => {
  const checkWishlistStatus = async () => {
    const userString = localStorage.getItem("user");
    const users = userString ? JSON.parse(userString) : null;
    const userId = users?.id || null;

    if (!userId || products.length === 0) return;

    const newLikedStatus = {};

    for (const product of products) {
      try {
        const res = await axiosClient.post("/check", {
          product_id: product.product_id,
          user_id: userId,
        });

        newLikedStatus[product.product_id] = res.status === 200;
      } catch (err) {
        newLikedStatus[product.product_id] = false;
      }
    }

    setLikedProducts(newLikedStatus);
  };

  checkWishlistStatus();
}, [products]);
  const handleWishlist = async (productId) => {
    const userString = localStorage.getItem("user");
    const user = userString ? JSON.parse(userString) : null;
    // const userId = users?.id || null;

    if (!user) {
      toast.error("Please log in to add to wishlist.");
      return;
    }

    try {
      const res = await postData("/update-wish", { 
        user_id: user.user_id, 
        product_id: productId 
      });

      if (res && res.status === 200) {
        setLikedProducts(prev => {
          const isCurrentlyLiked = prev[productId];
          toast.success(isCurrentlyLiked ? "Removed from wishlist." : "Added to wishlist.");
          return {
            ...prev,
            [productId]: !isCurrentlyLiked
          };
        });
      } else {
        toast.error("Failed to update wishlist.");
      }
    } catch (error) {
      toast.error("Failed to update wishlist.");
      console.error("Wishlist API error:", error);
    }
  };


  // useEffect(() => {
  //   const fetchAllProducts = async () => {
  //     try {
  //       const res = await getData("/all");
  //       setProducts(res.data);
  //     } catch (err) {
  //       console.error("Failed to load all products", err);
  //     }
  //   };

  //   fetchAllProducts();
  // }, []);
useEffect(() => {
  const fetchAllProducts = async () => {
    try {
      const res = await getData("/all");
      const allProducts = Array.isArray(res.data) ? res.data : [];

      // take off_all from returned products
      const offAllValue = allProducts.length > 0 ? Number(allProducts[0].off_all || 0) : 0;
      setOffAll(offAllValue);

      if (offAllValue === 1) {
        setProducts([]);
        return;
      }

      setProducts(allProducts);
    } catch (err) {
      console.error("Failed to load all products", err);
      setProducts([]);
      setOffAll(0);
    }
  };

  fetchAllProducts();
}, []);  const handleView = (id) => {
    navigate(`/product/${btoa(id.toString())}`);
  };
const observerRef = useRef([]);
useEffect(() => {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("card-visible");
        }
      });
    },
    { threshold: 0.2 }
  );

  observerRef.current.forEach((el) => {
    if (el) observer.observe(el);
  });

  return () => observer.disconnect();
}, [products]);
const cardRefs = useRef([]);
useEffect(() => {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("card-show");
        }
      });
    },
    {
      threshold: 0.15,
    }
  );

  cardRefs.current.forEach((card) => {
    if (card) observer.observe(card);
  });

  return () => observer.disconnect();
}, [products]);

  return (
    <div className="py-6 px-6 md:px-16">
     <div className="mb-10 flex justify-center">
  <div className="flex items-center gap-3 ">
    {/* <div className="flex items-center gap-3 w-[220px] sm:w-[280px] "> */}
    <EnhancedSearchBar baseURL={BASE_URL} />

    <button
      onClick={() => navigate("/shopping")}
      className="
        flex items-center gap-2
        bg-orange-500 text-white
        px-4 py-2 rounded-lg
        hover:bg-orange-600
        transition
        whitespace-nowrap
      "
    >
      <FiFilter size={18} />
      <span className="hidden sm:inline">Filter</span>
    </button>
  </div>
</div>


      {/* <h2 className="text-3xl font-bold mb-8 text-center">
       All Products
      </h2> */}
      {offAll !== 1 && (
  <h2 className="text-3xl font-bold mb-8 text-center">
    All Products
  </h2>
)}
{offAll === 1 ? (
  /* ============ NO PRODUCTS ============ */
  <div className="flex flex-col items-center justify-center mt-20 text-center">
    <h3 className="text-2xl font-semibold text-gray-800 mb-2">
       Shop is currently closed
    </h3>
    <p className="text-gray-500">
            We’re not accepting orders right now.  
      Please check back later when the shop is open.
    </p>
  </div>

):null}
{offAll !== 1 && (
      <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
        {/* {products.map((p) => ( */}
        {products.map((p, index) => (

  //         <div key={p.product_id} className="  group
  //   min-w-[160px] sm:min-w-[200px] md:min-w-0
  //   bg-white rounded-lg shadow

  //   opacity-100 translate-y-0
  //   transition-all duration-300 ease-out

  //   hover:shadow-xl hover:-translate-y-2 hover:scale-[1.03]
  //   active:shadow-xl active:-translate-y-2 active:scale-[1.03]
  // ">
  <div
  key={p.product_id}
  ref={(el) => (observerRef.current[index] = el)}
  className="
    card
    group
    bg-white rounded-lg shadow
    transition-all duration-500 ease-out

    hover:shadow-xl hover:-translate-y-2 hover:scale-[1.03]
    active:shadow-xl active:-translate-y-2 active:scale-[1.03]
  "
>
            <img
              src={`${baseURL}/uploads/${p.image_file}`}
              alt={p.product_name}
              loading="lazy"
              className="w-full h-48 object-cover"
            />
            <div
    className="absolute top-2 right-2 cursor-pointer z-10"
    onClick={() => handleWishlist(p.product_id)}
  >
    {likedProducts[p.product_id] ? (
      <FaHeart size={22} className="text-red-500" />
    ) : (
      <CiHeart size={22} className="text-gray-500" />
    )}
  </div>
            <div className="p-4 text-center">
              <h3 className="text-sm font-medium">{p.product_name}</h3>
              {/* <p className="text-blue-600 font-bold"> */}
                {/* ₹{p.unit_selling_price} */}
 {/* ₹{Number(p.unit_selling_price).toFixed(2)} */}
              {/* </p> */}
              <div className="flex items-center justify-center gap-2 mb-2">
  {/* Selling Price */}
  <span className="text-blue-600 font-bold">
    ₹{Number(p.unit_selling_price || 0).toFixed(2)}
  </span>


  {/* MRP Price */}
  {p.mrp_price && (
    <span className="text-red-500 text-sm line-through">
      ₹{Number(p.mrp_price).toFixed(2)}
    </span>
  )}
</div>
              <button
                className="text-white px-4 py-2 rounded bg-[#c97c5d] hover:bg-orange-300"
                onClick={() => handleView(p.product_id)}
              >
                View
              </button>
            </div>
          </div>
        ))}
      </div>
)}
    </div>
  );
};

export default Demo_4;
